import { brand, privacyNotice, storageMessages } from "@studystraight/shared-config";

/** §27 — phiên bị ngắt đang chờ người dùng quyết định lưu hay bỏ. */
export interface RecoveryPrompt {
  /** Ví dụ "19:30 · 24 phút" — đủ để nhận ra đó là phiên nào. */
  label: string;
  onAccept: () => void;
  onDiscard: () => void;
}

export interface HomeScreenProps {
  onStart: () => void;
  onHistory: () => void;
  onSettings: () => void;
  /** `null` khi không có phiên dở dang (trường hợp thường gặp). */
  recovery: RecoveryPrompt | null;
  /** Storage không dùng được (Safari private mode) — nói trước khi trẻ học xong 45 phút. */
  storageUnavailable: boolean;
}

/** §9 */
export function HomeScreen({
  onStart,
  onHistory,
  onSettings,
  recovery,
  storageUnavailable,
}: HomeScreenProps): React.JSX.Element {
  return (
    <main className="screen screen--centered">
      <header className="home__header">
        <h1 className="brand">{brand.name}</h1>
        <p className="tagline">{brand.tagline}</p>
      </header>

      {/* Hỏi ở Home chứ không tự lưu: một phiên bị kill giữa lúc trẻ đã rời bàn từ lâu có thể dài
          gấp đôi thời gian học thật, nên người dùng phải là người quyết định (§27). */}
      {recovery ? (
        <div className="banner" role="status">
          <span>
            {storageMessages.recoveryPrompt} ({recovery.label})
          </span>
          <div className="actions">
            <button type="button" className="btn btn--secondary" onClick={recovery.onDiscard}>
              Bỏ qua
            </button>
            <button type="button" className="btn btn--primary" onClick={recovery.onAccept}>
              Lưu lại
            </button>
          </div>
        </div>
      ) : null}

      <button type="button" className="btn btn--primary btn--lg" onClick={onStart}>
        {brand.primaryCta}
      </button>

      <nav className="home__secondary">
        <button type="button" className="btn btn--secondary" onClick={onHistory}>
          {brand.history}
        </button>
        <button type="button" className="btn btn--secondary" onClick={onSettings}>
          {brand.settings}
        </button>
      </nav>

      {storageUnavailable ? <p className="hint">{storageMessages.unavailable}</p> : null}

      {/* §7 — bắt buộc hiển thị ở Home và Camera Setup. */}
      <p className="privacy">{privacyNotice}</p>
    </main>
  );
}
